var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.descriptionHtml)?_c('pre',{directives:[{name:"safe-html",rawName:"v-safe-html:[$options.safeHtmlConfig]",value:(_vm.descriptionHtml),expression:"descriptionHtml",arg:_vm.$options.safeHtmlConfig}],staticClass:"gl-mb-0 gl-border-none"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }